/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Page_Faq_A3Inputs */

const en_invite_page_faq_a3 = /** @type {(inputs: Invite_Page_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. You can invite multiple people to help build your progress.`)
};

const ar_invite_page_faq_a3 = /** @type {(inputs: Invite_Page_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نعم. يمكنك دعوة عدة أشخاص للمساعدة في زيادة تقدمك.`)
};

const de_invite_page_faq_a3 = /** @type {(inputs: Invite_Page_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Du kannst mehrere Personen einladen, um deinen Fortschritt aufzubauen.`)
};

const es_invite_page_faq_a3 = /** @type {(inputs: Invite_Page_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Puedes invitar a varias personas para que te ayuden a avanzar.`)
};

const fr_invite_page_faq_a3 = /** @type {(inputs: Invite_Page_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Vous pouvez inviter plusieurs personnes pour vous aider à faire progresser votre avancée.`)
};

const it_invite_page_faq_a3 = /** @type {(inputs: Invite_Page_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Puoi invitare più persone per aiutarti ad avanzare.`)
};

const ja_invite_page_faq_a3 = /** @type {(inputs: Invite_Page_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。複数の人を招待して、進捗を増やすことができます。`)
};

const ko_invite_page_faq_a3 = /** @type {(inputs: Invite_Page_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네. 여러 사람을 초대해 진행도를 함께 쌓을 수 있어요.`)
};

const pt_br_invite_page_faq_a3 = /** @type {(inputs: Invite_Page_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Você pode convidar várias pessoas para ajudar a aumentar seu progresso.`)
};

const ru_invite_page_faq_a3 = /** @type {(inputs: Invite_Page_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да. Вы можете пригласить нескольких человек, чтобы они помогли увеличить ваш прогресс.`)
};

const th_invite_page_faq_a3 = /** @type {(inputs: Invite_Page_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ได้ คุณสามารถเชิญหลายคนมาช่วยสะสมความคืบหน้าได้`)
};

const tr_invite_page_faq_a3 = /** @type {(inputs: Invite_Page_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evet. İlerlemeni artırmaya yardımcı olması için birden fazla kişiyi davet edebilirsin.`)
};

const zh_cn_invite_page_faq_a3 = /** @type {(inputs: Invite_Page_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。你可以邀请多人一起帮你累积进度。`)
};

const zh_tw_invite_page_faq_a3 = /** @type {(inputs: Invite_Page_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。你可以邀請多人一起幫你累積進度。`)
};

/**
* | output |
* | --- |
* | "Yes. You can invite multiple people to help build your progress." |
*
* @param {Invite_Page_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const invite_page_faq_a3 = /** @type {((inputs?: Invite_Page_Faq_A3Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Page_Faq_A3Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invite_page_faq_a3(inputs)
	if (locale === "ar") return ar_invite_page_faq_a3(inputs)
	if (locale === "de") return de_invite_page_faq_a3(inputs)
	if (locale === "es") return es_invite_page_faq_a3(inputs)
	if (locale === "fr") return fr_invite_page_faq_a3(inputs)
	if (locale === "it") return it_invite_page_faq_a3(inputs)
	if (locale === "ja") return ja_invite_page_faq_a3(inputs)
	if (locale === "ko") return ko_invite_page_faq_a3(inputs)
	if (locale === "pt_br") return pt_br_invite_page_faq_a3(inputs)
	if (locale === "ru") return ru_invite_page_faq_a3(inputs)
	if (locale === "th") return th_invite_page_faq_a3(inputs)
	if (locale === "tr") return tr_invite_page_faq_a3(inputs)
	if (locale === "zh_cn") return zh_cn_invite_page_faq_a3(inputs)
	return zh_tw_invite_page_faq_a3(inputs)
});